/**
 * Created by Jan Bradac on 29.4.2016.
 */

/**
 * Registers, marks and provides identifiers to access important sections of the page in Lyfle.
 */
Lfl.PageSectionsManager;

(function (Lfl, $, undefined) {
    (function (PageSectionsManager, $, undefined) {

        /**
         * The jq objects to access various sections of the page
         * @type {{string: jQuery}}
         */
        var sections = {};

        /*
         |---------------------------------------------------------------------------------------------------------------
         | Identifiers
         |---------------------------------------------------------------------------------------------------------------
         | Even though those constants might seem redundant, their main purpose is to ensure that no miss-spellings will
         | occur. One "javacsript" instead of "javascript" is enough to cause serious issues.
         */
        var DATA_IDENTIFIER = 'data-lfl-section';
        var JAVASCRIPT_IDENTIFIER = 'javascript';


        /**
         * The name with which the section where flash messages should be placed should be registered.
         *
         * Also should be used as an identifier of flash messages in JSON response sent by server.
         *
         * Not directly linked to PHP code.
         *
         * @type {string}
         */
        var FLASH_MESSAGES_IDENTIFIER = "flash-messages";


        /**
         *
         * @param $section
         * @memberOf Lfl.PageSectionsManager
         */
        PageSectionsManager.registerTheMainJavascriptSection = function ($section) {
            $section.attr(DATA_IDENTIFIER, JAVASCRIPT_IDENTIFIER);
            sections[JAVASCRIPT_IDENTIFIER] = $section;
        };

        /**
         *
         * @param $section
         * @memberOf Lfl.PageSectionsManager
         */
        PageSectionsManager.registerFlashMessagesSection = function ($section) {
            $section.attr(DATA_IDENTIFIER, FLASH_MESSAGES_IDENTIFIER);
            sections[FLASH_MESSAGES_IDENTIFIER] = $section;
        };

        /*
        |---------------------------------------------------------------------------------------------------------------
        | Getters
        |---------------------------------------------------------------------------------------------------------------
        */
        /*
         |-------------------------------------------------------------------------
         | Sections */

        /**
         * @memberOf Lfl.PageSectionsManager
         */
        PageSectionsManager.getSection = function (sectionId) {
            return sections[sectionId];
        };

        /**
         * Returns a jq wrapper around the section where javascript should be inserted.
         * @memberOf Lfl.PageSectionsManager
         */
        PageSectionsManager.getJavascriptSection = function () {
            return PageSectionsManager.getSection(JAVASCRIPT_IDENTIFIER);
        };

        /**
         * Returns a jq wrapper around the section where flash messages should be inserted.
         * @memberOf Lfl.PageSectionsManager
         */
        PageSectionsManager.getFlashMessagesSection = function () {
            return PageSectionsManager.getSection(FLASH_MESSAGES_IDENTIFIER);
        };

        /*
         |-------------------------------------------------------------------------
         | Section names */

        /**
         * @memberOf Lfl.PageSectionsManager
         * @return {string}
         */
        PageSectionsManager.getDataIdentifier = function () {
            return DATA_IDENTIFIER;
        };

        /**
         * @memberOf Lfl.PageSectionsManager
         * @return {string}
         */
        PageSectionsManager.getJavascriptSectionIdentifier = function() {
            return JAVASCRIPT_IDENTIFIER;
        };


        /**
         * @memberOf Lfl.PageSectionsManager
         * @return {string}
         */
        PageSectionsManager.getFlashMessagesSectionIdentifier = function() {
            return FLASH_MESSAGES_IDENTIFIER;
        }


    }(Lfl.PageSectionsManager = Lfl.PageSectionsManager || {}, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));
